import { useMemo } from 'react';
import FilteredProducts from './FilteredProducts';
import { Product } from '../../types';
import { useContext } from '../RenderContext';
import ProductsBase from './ProductsBase';

export const Ssl = () => {
  const { tag } = useContext();
  const products = tag?.products ?? [];

  // Only include filters where at least one product matches
  const filters = useMemo(() => {
    const allFilters = [{
      key: 'dv',
      filter: (p: Product) => p.tags.includes('dv')
    }, {
      key: 'ov',
      filter: (p: Product) => p.tags.includes('ov')
    }, {
      key: 'ev',
      filter: (p: Product) => p.tags.includes('ev')
    }];

    // Filter out tabs that have no matching products
    return allFilters.filter(({ filter }) =>
      products.some(product => filter(product))
    );
  }, [products]);
  // If no filters have matching products, render the base product list
  // backwards compatible with the API version that don't include product tags
  if (filters.length === 0) {
    return <ProductsBase useDefaultLayout={ true } />;
  }

  return (
    <FilteredProducts
      filters={ filters }
    />
  );
};

export default Ssl;
